export class PlanModel {
  name: string;
  price: number;
  priceRecurring: number;
  summary: string;
  serviceFee: number;
  id: string;
  isRealEstateCoverage: boolean;
  isHomeownerCoverage: boolean;
  isRenewalCoverage: boolean;
  activeDateStart?: any;
  activeDateEnd?: any;
  isSingleFamily: boolean;
  isCondo: boolean;
  isDuplex: boolean;
  isTriplex: boolean;
  isFourplex: boolean;
  showOnWeb: boolean;
  squareFootageAdjustmentId: string;
  ageOfHomeAdjustmentId: string;
  renewalProfitabilityAdjustmentId: string;
  coverageTypeAdjustmentId: string;
  coverageLength: number;
  dwellingTypeAdjustmentId: string;
  monthlyProcessingFee: number;
  planColor: string;
  termsAndLimitationId: string;
  contractTemplateName: string;
  renewalPlanId: string;
  recallPeriod: number;
  cancelationFee: number;
  areaAdjustmentId: string;

  // Non-persisted properties
  standardItems: SalesItemModel[] = [];
  optionalItems: SalesItemModel[] = [];
  removing = false;

  // planStandardItems: PlanItemSummaryModel[] = [];
  // planOptionalItems: PlanItemSummaryModel[] = [];

  selected: boolean;
  isBestValue: boolean;
}

export class SalesItemModel {
  constructor(public name = '', public category = '', public price = 0,
              public priceRecurring = 0, public allowQuantity = false,
              public selected = false, public quantity = 1,
              public planItemId: string = null,
              public salesItemCoverageId: string = null,
              public inSelectAreas: boolean = false,
              public requirements: any = null,
              public salesItemId: string = null) {}
  unique = false;
}


export class PlanGridModel {
  plans: PlanModel[];
  categories: PlanGridCategoryModel[] = [];

  public static getPlanGridModel(plans: PlanModel[]): PlanGridModel {
    const planGridModel = new PlanGridModel();

    planGridModel.plans = plans;

    plans.forEach(plan => {

      plan.standardItems.forEach(standardItem => {

        let category = planGridModel.categories.filter(
            i => i.categoryName === standardItem.category)[0];
        if (!category) {
          category = new PlanGridCategoryModel();
          category.categoryName = standardItem.category;
          planGridModel.categories.push(category);
        }

        let item = category.items.filter(i => i.salesItemName ===
                                              standardItem.name)[0];
        if (!item) {
          item = new PlanGridItemModel();
          item.salesItemName = standardItem.name;
          item.planItemId = standardItem.planItemId;
          item.salesItemCoverageId = standardItem.salesItemCoverageId;
          item.inSelectAreas = standardItem.inSelectAreas;
          category.items.push(item);
        }

        let i = item.planAvailability.length;
        const planCount = plans.indexOf(plan);

        while (i < planCount) {
          item.planAvailability.push(new PlanGridItemAvailabilityModel(false));
          i++;
        }
        item.planAvailability.push(
            new PlanGridItemAvailabilityModel(true, plan));
      });

    });

    planGridModel.categories.forEach(category => {
      category.items.forEach(item => {
        for (let i = item.planAvailability.length; i < plans.length; i++) {
          item.planAvailability.push(new PlanGridItemAvailabilityModel(false));
        }
      });
    });

    planGridModel.plans.forEach(p => p.selected = true);
    return planGridModel;
  }
}

export class PlanGridCategoryModel {
  categoryName: string;
  items: PlanGridItemModel[] = [];
}

export class PlanGridItemModel {
  salesItemName: string;
  inSelectAreas: boolean;
  planAvailability: PlanGridItemAvailabilityModel[] = [];
  planItemId: string;
  salesItemCoverageId: string;

}

export class PlanGridItemAvailabilityModel {
  constructor(public available: boolean, public plan: PlanModel = null) {}
}
